import { useFormContext } from "react-hook-form";
import Label from "components/atoms/forms/Label";
import BigImageUpload from "components/atoms/UploadImage";
import { useMemo } from "react";
import Icon, { MagnetiqIcon } from "../atoms/Icon";
import ProfileImageElement from "../molecules/ProfileImageElement";
import SocialLinkElement from "../molecules/forms/SocialLinkElement";
import LinksIcon from "../../assets/Icons/Links.svg";
import { ProfileUploadWithCustomOnChange } from "../atoms/ProfileUpload";
import ErrorMessage from "../atoms/forms/ErrorMessage";

function BrandProfileForm() {
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
  } = useFormContext();

  const handleSetCoverImageValue = (file: FileList) => {
    setValue("cover_image", file, {
      shouldValidate: true,
    });
  };

  const handleSetProfileImageValue = (file: FileList) => {
    setValue("profile_image", file, {
      shouldValidate: true,
    });
  };

  const handleClearCoverImage = () => {
    setValue("cover_image", null);
  };

  const profileImage = watch("profile_image") && watch("profile_image")[0];
  const coverImage = watch("cover_image") && watch("cover_image")[0];

  const profileImgSrc = useMemo(() => (profileImage ? URL.createObjectURL(profileImage) : null), [profileImage]);

  return (
    <div className="grid grid-cols-10 gap-y-2 md:gap-x-12 md:gap-y-3">
      <div className="col-span-10 flex items-center gap-5 md:col-span-3">
        {/* TODO: Replace Null with image_url */}
        <ProfileImageElement
          label="Brand Logo*"
          profileImage={profileImgSrc}
          defaultImage={<MagnetiqIcon />}
          alt="Brand profile image"
        />
        <div className="mt-7 flex h-12 w-24 items-center">
          <ProfileUploadWithCustomOnChange
            setFieldValue={handleSetProfileImageValue}
            id="profile_image"
            label={profileImage ? "CHANGE IMAGE" : "UPLOAD IMAGE"} // remove when pencil button is used
          />
        </div>
      </div>
      <div className="col-span-10">
        <ErrorMessage errorMessage={errors.profile_image?.message} />
      </div>

      <div className="h-62 col-span-10">
        <Label htmlFor="cover_image" label="Cover Image*" />
        <div className="aspect-1">
          <BigImageUpload
            setFieldValue={handleSetCoverImageValue}
            // @ts-ignore
            errors={errors.cover_image?.message}
            choosenFile={coverImage}
            id="cover_image"
            label="Upload a file or Drag and Drop"
            labelClasses="font-medium text-lg font-satoshi"
            subLabel="PNG,JPG,GIF upto 10MB"
            handleClearImage={handleClearCoverImage}
          />
        </div>
      </div>
      <div className="col-span-10">
        <Icon src={LinksIcon} text="Links" imageContainerClasses="w-9 h-9" />
      </div>

      <div className="col-span-10  md:col-span-5">
        <SocialLinkElement
          getValues={getValues}
          setValue={setValue}
          id="website_link"
          label="Website*"
          register={register}
          errorMessage={errors.website_link?.message}
        />
      </div>
      <div className=" col-span-10 md:col-span-5">
        <SocialLinkElement
          getValues={getValues}
          setValue={setValue}
          id="instagram_link"
          placeHolder="Enter Instagram Link"
          label="Instagram"
          register={register}
          errorMessage={errors.instagram_link?.message}
        />
      </div>
      <div className="col-span-10 md:col-span-5">
        <SocialLinkElement
          getValues={getValues}
          setValue={setValue}
          id="twitter_link"
          label="Twitter"
          placeHolder="Enter Twitter Link"
          register={register}
          errorMessage={errors.twitter_link?.message}
        />
      </div>
      <div className="col-span-10 md:col-span-5">
        <SocialLinkElement
          getValues={getValues}
          setValue={setValue}
          id="other_link"
          placeHolder="Enter Other Link"
          label="Other Links"
          register={register}
          errorMessage={errors.other_link?.message}
        />
      </div>
    </div>
  );
}
export default BrandProfileForm;
